import { Fragment, useEffect } from 'react'
import ManagementRolesLayout from './ManagementRolesLayout'
import { useAuthState } from 'packages/core'
import useSubcomponents from 'useSubcomponents'
import { usePageContext } from 'pageContext'

const allFilters = [
    {
        name: 'OwnedByFilter',
        requireAccess: 'ResourceAdmin-ManagementRole-Filter-OwnedBy',
    },
    {
        name: 'applicationsFilter',
        requireAccess: 'ResourceAdmin-ManagementRole-Filter-Applications',
    },
    {
        name: 'managementRolesLocationFilter',
        requireAccess: 'ResourceAdmin-ManagementRole-Filter-Location',
    },
    {
        name: 'businessFunctionFilter',
        requireAccess: 'ResourceAdmin-ManagementRole-Filter-BusinessFunctions',
    },
    {
        name: 'globalRightsFilter',
        requireAccess: 'ResourceAdmin-ManagementRole-Filter-Rights',
    },
    {
        name: 'advancedSearch',
        requireAccess: 'ResourceAdmin-ManagementRole-Filter-AdvancedSearch',
        config: {
            title: 'Common_Forms',
            colorCode: {
                primary: '#2920ad',
                secondary: '#ebeaf7',
            },
            filters: [
                {
                    name: 'friendlyName',
                    type: 'text',
                    label: 'Common_Name',
                    placeholder: 'Common_Name',
                    contextProp: 'advancedSearch.forms.friendlyName',
                },
                {
                    name: 'description',
                    type: 'text',
                    label: 'Common_Description',
                    placeholder: 'Common_Description',
                    contextProp: 'advancedSearch.forms.description',
                },
            ],
            tags: {
                title: 'Common_Tags',
                colorCode: {
                    primary: '#f81983',
                    secondary: '#fee8f2',
                },
                contextProp: 'advancedSearchTags',
            },
        },
    },
]

const RequestViewAllManagementRoles = () => {
    const [, dispatch] = usePageContext()

    const [{ currentUserId, friendlyName }] = useAuthState()

    const { trimControlsBasedOnAccess } = useSubcomponents()

    const filters = trimControlsBasedOnAccess(allFilters)
    const hasOwnedByFilterAccess =
        filters.map((f) => f.name).indexOf('OwnedByFilter') >= 0
    useEffect(() => {
        if (!hasOwnedByFilterAccess) {
            dispatch({
                type: 'SET_MULTIPLE_PROPS',
                payload: {
                    ownedBy: {
                        id: currentUserId,
                        friendlyName: friendlyName,
                    },
                    enableOwnedByApiCall: true,
                },
            })
        } else {
            dispatch({
                type: 'SET_PROP',
                payload: {
                    key: 'enableOwnedByApiCall',
                    value: true,
                },
            })
        }
    }, [currentUserId])
    return (
        <Fragment>
            <ManagementRolesLayout filters={filters} />
        </Fragment>
    )
}

export { RequestViewAllManagementRoles }
